'use client';

import { useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { NamespacesI18n } from '@storefront/i18n';

import styles from './index.module.scss';
import { ModalAccessories } from '../index';

interface ModalHubProps {
  model?: string;
}

export const ModalHub = () => {
  const i18nPrefix = 'pc.modalHub';
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: i18nPrefix,
  });
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const features: string[] = t('featuresList', { returnObjects: true });

  return (
    <>
      <ModalAccessories
        title="modal-hub"
        show={showModal}
        className={styles['modal-container']}
        i18nPrefix={i18nPrefix}
        styles={styles}
        featuresImg={{
          src: 'modal-hub-1.png',
          alt: 'keyboard and mouse',
          width: 400,
          height: 0,
          quality: 100,
          className: styles['vertical-image'],
        }}
        bottomImg={{
          src: 'modal-hub-2.png',
          alt: 'keyboard and mouse',
          width: 840,
          height: 0,
          quality: 100,
          className: styles['horizontal-image'],
        }}
        features={
          <div className={`title-regular ${styles['title']}`}>
            <Trans t={t} i18nKey={`features`} />
            <ul className={styles['list']}>
              {features.map((feature) => (
                <li className={`body-large`} key={feature}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        }
        onClose={handleClose}
      />
      <input
        id="open-modal-hub"
        data-testid="modal-hub"
        tabIndex={0}
        className={styles['modal-button']}
        aria-label="modal hub"
        type="button"
        value={t('link')}
        onClick={async () => {
          setShowModal(true);
        }}
      />
    </>
  );
};
